// extracted by mini-css-extract-plugin
module.exports = {"view":"about_view_3xGv6","wrapper":"about_wrapper_5_aiH","content":"about_content_3gOU8","credits":"about_credits_2j8KP"};